export const BNGM_OPTION_LISTS_EMPTY_MESSAGE =
  "Aucune liste d'options éligible pour ce point de vente";

export const BNGM_OPTION_LISTS_ERROR_MESSAGE =
  "Impossible de charger les listes d'options éligibles. Veuillez réessayer.";

export const BNGM_OPTION_LISTS_LOADING_MESSAGE =
  "Chargement des listes d'options éligibles...";
